/**
 * Shared table chrome.
 *
 * Class strings rather than a generic <DataTable> component: every table here
 * has a different column shape and a different reason to exist, and a generic
 * one would end up with a prop for each of those differences anyway. What must
 * be shared is the chrome, so that is what is shared.
 */

export const TABLE = 'w-full text-sm'

/** Sticky so the header survives scrolling inside a fixed-height panel. */
export const THEAD = 'sticky top-0 z-10 bg-surface'

export const TH =
  'border-b border-line-subtle px-2 py-1 text-left text-micro font-medium uppercase tracking-label text-fg-muted whitespace-nowrap'

/** Numeric columns are right-aligned and tabular. Anything else jitters. */
export const TH_NUM = `${TH} text-right`

export const TD = 'border-b border-line-subtle px-2 py-1 text-fg-secondary'

export const TD_NUM = `${TD} text-right live-value font-mono text-fg`

export const TR = 'hover:bg-inset'

/** Sortable header button — the whole cell is the hit target. */
export const TH_BUTTON =
  'flex w-full items-center gap-1 text-micro font-medium uppercase tracking-label text-fg-muted hover:text-fg'
